import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import CountryTaxLayer from "./CountryTaxLayer";

const CountryTaxPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Country Tax" />
      <CountryTaxLayer />
    </MasterLayout>
  );
};

export default CountryTaxPage;

